/**
 * KAYU Legends carousel — half-slide peek, continuous linear scroll (no pause).
 * Pauses while the pointer is over the slider (images / track).
 */
(function () {
  var SELECTOR = "[data-kayu-legends-slider]";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function initSlider(root) {
    if (root.getAttribute("data-kayu-initialized") === "true") return;
    root.setAttribute("data-kayu-initialized", "true");

    var track = root.querySelector("[data-track]");
    var viewport = root.querySelector("[data-viewport]") || root;
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children);
    var n = originals.length;
    if (n === 0) return;

    originals.forEach(function (node) {
      track.appendChild(node.cloneNode(true));
    });

    var loopMs = parseInt(root.getAttribute("data-loop-duration-ms"), 10);
    if (isNaN(loopMs) || loopMs < 1000) loopMs = 30000;

    var reduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var rafId = null;
    var paused = false;
    var loopOffset = 0;
    var lastFrameTime = 0;
    var marquee = null;

    function stopAnim() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    function stepPx() {
      var first = track.children[0];
      var w =
        first && first.getBoundingClientRect().width > 0
          ? first.getBoundingClientRect().width
          : 228.571;
      var styles = window.getComputedStyle(track);
      var g = parseFloat(styles.columnGap || styles.gap, 10);
      if (isNaN(g)) g = 24;
      return w + g;
    }

    function peekPx() {
      var first = track.children[0];
      return first && first.getBoundingClientRect().width > 0
        ? first.getBoundingClientRect().width / 2
        : 114.285;
    }

    function applyTransform(progress) {
      if (!marquee) return;
      var x =
        marquee.startX + (marquee.endX - marquee.startX) * progress;
      track.style.transform = "translate3d(" + x + "px, 0, 0)";
    }

    function applyStatic() {
      stopAnim();
      paused = false;
      marquee = null;
      track.classList.remove("kayu-legends-slider__track--marquee");
      track.style.animation = "none";
      track.style.transition = "none";
      var peek = peekPx();
      track.style.transform = "translate3d(" + -peek + "px, 0, 0)";
    }

    function frame(now) {
      if (paused || !marquee) {
        rafId = null;
        return;
      }

      if (!lastFrameTime) lastFrameTime = now;
      var delta = now - lastFrameTime;
      lastFrameTime = now;

      loopOffset = (loopOffset + delta) % marquee.duration;
      applyTransform(loopOffset / marquee.duration);

      rafId = requestAnimationFrame(frame);
    }

    function startAnim() {
      stopAnim();
      lastFrameTime = 0;
      rafId = requestAnimationFrame(frame);
    }

    function pauseMarquee() {
      if (reduced || paused || !marquee) return;
      paused = true;
      stopAnim();
      root.classList.add("kayu-legends-slider--paused");
    }

    function resumeMarquee() {
      if (reduced || !paused || !marquee) return;
      paused = false;
      root.classList.remove("kayu-legends-slider--paused");
      lastFrameTime = 0;
      startAnim();
    }

    function applyMarquee() {
      stopAnim();
      track.classList.add("kayu-legends-slider__track--marquee");
      track.style.animation = "none";
      track.style.transition = "none";

      var peek = peekPx();
      var step = stepPx();
      var distance = n * step;
      if (distance <= 0) return;

      marquee = {
        startX: -peek,
        endX: -peek - distance,
        duration: loopMs,
      };

      applyTransform(loopOffset / loopMs);
      paused = false;
      root.classList.remove("kayu-legends-slider--paused");
      startAnim();
    }

    function setup() {
      if (reduced) {
        applyStatic();
        return;
      }
      applyMarquee();
    }

    function setupWhenReady() {
      requestAnimationFrame(function () {
        requestAnimationFrame(setup);
      });
    }

    viewport.addEventListener("mouseenter", pauseMarquee);
    viewport.addEventListener("mouseleave", resumeMarquee);
    viewport.addEventListener("focusin", pauseMarquee);
    viewport.addEventListener("focusout", function (e) {
      if (!viewport.contains(e.relatedTarget)) resumeMarquee();
    });

    setupWhenReady();
    window.addEventListener("load", setupWhenReady);
    window.addEventListener(
      "resize",
      debounce(function () {
        loopOffset = 0;
        setupWhenReady();
      }, 150)
    );

    document.addEventListener("shopify:section:load", function (e) {
      if (e.target && e.target.contains && e.target.contains(root)) {
        loopOffset = 0;
        setupWhenReady();
      }
    });
  }

  ready(function () {
    document.querySelectorAll(SELECTOR).forEach(initSlider);
  });
})();
